<template>
    <div class="btn-list">
        <button @click="clickEvent">{{text}}</button>
        <button @click="close" v-if="+nums > 1">关闭</button>
    </div>
</template>
<script>
import {jump} from '@utils'
export default {
    props:{
        text:{
            type:String,
            default:'提交'
        },
        nums:{
            type:String,
            default:'2'
        }
    },
    methods:{
        clickEvent(){
            this.$emit('handle')
        },
        close(){
            jump.closeCurrent();
        }
    }
}
</script>
<style lang="scss" scoped>
.btn-list{
     @include Flex;
    justify-content: center;
    padding-top: 35px;
    button {
        border-radius: 16px;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        line-height: 30px;
        height: 32px;
        padding: 0 20px;
        border: 1px solid #FF397E;
        min-width: 124px;
        color: #FF397E;
        text-align: center;
        background-color: #fff;
        cursor: pointer;
        margin-left: 10px;
        &:first-child {
            line-height: 32px;
            border: 0;
            color: #fff;
            background-color: #FF397E;
            margin-right: 10px;
        }
    }
}
</style>



